import React from 'react';
import { isAlphaNumericKey, isNavigationKey, keyCodes } from '@silevis/reactgrid';

class DealboardCommissionDueCellTemplate {
  getCompatibleCell(uncertainCell) {
    const { commissionValues = [], onClick = () => {}, text = '' } = uncertainCell;

    return {
      commissionValues,
      onClick,
      text,
      nonEditable: true
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode)) return { cell, enableEditMode: false };
    return {
      cell,
      enableEditMode: keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER
    };
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    return <DealboardCommissionDueCellRenderer commissionValues={cell.commissionValues} onClick={cell.onClick} />;
  }
}

const DealboardCommissionDueCellRenderer = ({ commissionValues = [], onClick }) => {
  const hasValues = commissionValues.length > 0;

  const unitRowStyle = index => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px',
    borderTop: index === 0 ? 'none' : '1px solid #e9ecef',
    width: '100%'
  });

  return (
    <div
      className="dealboard-commission-due-cell"
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: hasValues ? 'pointer' : 'default',
        width: '100%',
        backgroundColor: '#F8F9FA'
      }}
      onClick={e => {
        e.stopPropagation();
        if (hasValues) onClick();
      }}
      onPointerDown={e => e.stopPropagation()}
      onKeyDown={e => {
        if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
          e.stopPropagation();
        }
      }}
    >
      {hasValues ? (
        commissionValues.map((value, idx) => (
          <div key={idx} style={unitRowStyle(idx)}>
            <p style={{ fontSize: '12px', margin: 0, fontWeight: 600 }}>
              {typeof value === 'number' ? value.toFixed(2) : '-'}
            </p>
          </div>
        ))
      ) : (
        <p style={{ fontSize: '12px', margin: 0, textAlign: 'center' }}>-</p>
      )}
    </div>
  );
};

export const dealboardCommissionDueCellTemplate = new DealboardCommissionDueCellTemplate();
